import React from 'react';
import { Box, Typography, Card } from '@mui/material';
import { useLocation } from 'react-router-dom';

const TempTnc = () => {
  const location = useLocation();
  const tncData = location.state?.tnc || [];
  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Card sx={{ p: 2, borderRadius: 2, boxShadow: 1 }}>
        <Typography
          variant='body1'
          sx={{ mb: 2 }}
        >
          <ol style={{ paddingLeft: '1.25rem' }}>
            {tncData.map((item, index) => (
              <li key={index}>
                <Typography variant="body2" sx={{ mb: 2 }} component="span">
                  {item}
                </Typography>
              </li>
            ))}
          </ol>

        </Typography>
      </Card>
    </Box>
  );
};

export default TempTnc;
